var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNopayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8511 23.9254V10.6269C36.8511 8.6238 35.2273 7 33.2242 7H21.1347C19.1316 7 17.5078 8.6238 17.5078 10.6269V23.9254",
    stroke: "#E2E5E8",
    strokeWidth: 4.83582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9404 19.0898V45.0824C48.9404 46.4177 47.8578 47.5003 46.5224 47.5003H7.83588C6.50051 47.5003 5.41797 46.4177 5.41797 45.0824V17.8809",
    stroke: "#E2E5E8",
    strokeWidth: 4.83582,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.6718C3 15.3364 4.08254 14.2539 5.41791 14.2539H48.9403C50.2757 14.2539 51.3582 15.3364 51.3582 16.6718V19.0897H3V16.6718Z",
    fill: "#E2E5E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopayment);
export default __webpack_public_path__ + "static/media/No payment.2637948d5d41b654082225f876fefd3f.svg";
export { ForwardRef as ReactComponent };